import React from 'react';
import { ExtendedVesselIntegrityInformation } from './ShipDetailsTabs/IntegrityInformation';
import { ExtendedVesselRegisterInformation } from './ShipDetailsTabs/RegisterInformation';
import { ExtendedVesselAdvancedInformation } from './ShipDetailsTabs/AdvancedVesselInformation';
import { VesselResult } from '@ais-ui/api-spec/shipdb';
import { ExtendedVesselBaseInformation } from './ShipDetailsTabs/ExtendedVesselBaseInformation';
import { TargetTab } from './targetTypes';

interface ShipComponentProps {
  shipInfo: VesselResult;
  tab: TargetTab;
}

export const ExtendedVesselDetailsPanel = ({
  shipInfo,
  tab,
}: ShipComponentProps) => {
  if (tab === 'base') {
    return (
      <ExtendedVesselBaseInformation
        shipInfo={shipInfo}
      ></ExtendedVesselBaseInformation>
    );
  } else if (tab === 'integrity') {
    return (
      <ExtendedVesselIntegrityInformation
        extendedVesselInfo={shipInfo}
      ></ExtendedVesselIntegrityInformation>
    );
  } else if (tab === 'register') {
    return (
      <ExtendedVesselRegisterInformation
        extendedVesselInfo={shipInfo}
      ></ExtendedVesselRegisterInformation>
    );
  } else if (tab === 'advancedVessel') {
    return (
      <ExtendedVesselAdvancedInformation
        extendedVesselInfo={shipInfo}
      ></ExtendedVesselAdvancedInformation>
    );
  }
};
